import { render } from "./SubmissionsDataTable.vue?vue&type=template&id=80f9aa0a&scoped=true"
import script from "./SubmissionsDataTable.vue?vue&type=script&lang=js"
export * from "./SubmissionsDataTable.vue?vue&type=script&lang=js"

import "./SubmissionsDataTable.vue?vue&type=style&index=0&id=80f9aa0a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f9aa0a"]])

export default __exports__